import { IShimmerStyles, IStackProps } from "@fluentui/react";
import React from "react";

import { Stack } from "../layouts/stack/Stack";
import { Shimmer } from "../progress/Shimmer";

export type FormShimmerProps = Pick<IStackProps, "children" | "styles"> & {
    isLoading: boolean;
};

export const FormShimmer: React.FunctionComponent<FormShimmerProps> = ({
    isLoading,
    children,
    styles
}: FormShimmerProps) => {
    const fields = Array.isArray(children) ? children : [children];

    const renderFields = () =>
        fields.map((child, index) =>
            isLoading ? <Shimmer key={`form-shimmer-${index}`} styles={shimmerStyles} /> : child
        );

    return (
        <Stack tokens={{ childrenGap: 10 }} styles={styles}>
            {renderFields()}
        </Stack>
    );
};

const shimmerStyles: IShimmerStyles = { root: { paddingTop: 10 }, shimmerWrapper: { height: 32 } };
